!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="Gl Zl Jl Ql Yl init wu mu yu Cu Pa bu Mu fu Au Pu Fu capture getExtension ku Wl Du calculateEventProperties $u register register_once register_for_session unregister unregister_for_session ju gu Lu getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync Bu identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset Hu shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty Nu Ru createPersonProfile setInternalOrTestUser qu tu eu opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Iu debug Fa bs getPageViewId captureTraceFeedback captureTraceMetric hu".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
// Cross-site identity (VETS-13285): veterinarians.org advertorial CTAs link here with
// #distinct_id=<uuid>&session_id=<uuid> (same PostHog project) so the visitor continues as the
// same person and session instead of starting over as a new anonymous visitor. Runs before
// posthog.init: reads the ids, drops them from the URL (so they never reach $current_url,
// $initial_* properties or a shared link), then decides:
//   - no PostHog identity in this browser, or an anonymous one -> bootstrap the incoming ids
//     (bootstrap overwrites the stored id without a merge, so a later identify(email) still merges
//     this anonymous id into the customer as usual);
//   - an identified customer (email) already in this browser -> keep them and alias the incoming
//     anonymous id to them after load, so neither person is overwritten or split.
// Visitors without the hash are untouched. Every step is fail-safe: never throws.
window.tvPhCross = (function () {
  var TOKEN = 'phc_tY266gUd6DBBovfxwVAcsypc53e2MNQJurnZV4f22bXQ';
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var out = { bootstrap: null, aliasTo: null };
  try {
    var hash = String(window.location.hash || '');
    if (hash.indexOf('distinct_id=') === -1) return out;
    var params = new URLSearchParams(hash.replace(/^#/, ''));
    var distinctId = String(params.get('distinct_id') || '');
    var sessionId = String(params.get('session_id') || '');
    try { history.replaceState(history.state, '', window.location.pathname + window.location.search); } catch (e) {}
    if (!UUID.test(distinctId)) return out; // never bootstrap "undefined" or junk
    if (!UUID.test(sessionId)) sessionId = '';
    var existing = '';
    var identified = false;
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)ph_' + TOKEN + '_posthog=([^;]+)'));
      if (m) existing = String(JSON.parse(decodeURIComponent(m[1])).distinct_id || '');
    } catch (e) {}
    try {
      var stored = JSON.parse(localStorage.getItem('ph_' + TOKEN + '_posthog') || '{}') || {};
      if (!existing) existing = String(stored.distinct_id || '');
      identified = stored.$user_state === 'identified';
    } catch (e) {}
    try { if (localStorage.getItem('tv_ph_customer')) identified = true; } catch (e) {}
    if (existing === distinctId) return out; // already the same visitor
    if (existing && identified) { out.aliasTo = distinctId; return out; }
    out.bootstrap = { distinctID: distinctId };
    if (sessionId) out.bootstrap.sessionID = sessionId;
  } catch (e) {}
  return out;
})();

(function () {
  var config = {
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-05-30',
    person_profiles: 'identified_only',
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]'
    }
  };
  try { if (window.tvPhCross && window.tvPhCross.bootstrap) config.bootstrap = window.tvPhCross.bootstrap; } catch (e) {}
  posthog.init('phc_tY266gUd6DBBovfxwVAcsypc53e2MNQJurnZV4f22bXQ', config);
})();

/**
 * hpPh — Honest Paws PostHog helper + site-wide first-touch attribution.
 * Loaded with async in <head> (theme.liquid), so window.hpPh may not exist yet when
 * a section script runs: callers must check for it. Every method is fail-safe: never throws.
 *
 * - capture() proxies posthog.capture (the stub queues until array.js lands).
 * - distinctId()/sessionId() need the REAL library (return values), so they
 *   yield undefined until posthog.__loaded is truthy.
 * - The attribution recorder runs on every page load: a NEW channel signal
 *   (utm_source or an ad click id) overwrites localStorage hp_attr_v1 with a
 *   30-day TTL; a load with no signal never clears or overwrites it. The
 *   current value is registered as a PostHog super property so it rides on
 *   every autocapture event.
 */
window.hpPh = (function () {
  var ATTR_KEY = 'hp_attr_v1';
  var ATTR_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

  function ready() {
    try { return !!(window.posthog && window.posthog.__loaded); } catch (e) { return false; }
  }
  function capture(event, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(event, props || {});
      }
    } catch (e) {}
  }
  function distinctId() {
    try { return ready() ? window.posthog.get_distinct_id() : undefined; } catch (e) { return undefined; }
  }
  function sessionId() {
    try { return ready() ? window.posthog.get_session_id() : undefined; } catch (e) { return undefined; }
  }

  function sanitize(value) {
    if (!value) return '';
    var v = String(value).trim().toLowerCase();
    return /^[a-z0-9_-]{1,40}$/.test(v) ? v : '';
  }

  // Acquisition channel carried by THIS page load, or '' when there's no
  // signal. utm_source wins (normalized), then ad click ids.
  function channelFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var utm = sanitize(params.get('utm_source'));
      if (utm) {
        if (utm === 'facebook' || utm === 'fb' || utm === 'meta') return 'fb';
        if (utm === 'instagram') return 'ig';
        if (utm === 'google') return 'google';
        if (utm === 'tiktok') return 'tt';
        if (utm === 'klaviyo') return 'klaviyo';
        return utm; // other sanitized values pass through as-is
      }
      if (params.get('fbclid')) return 'fb';
      if (params.get('gclid') || params.get('gbraid') || params.get('wbraid')) return 'google';
      if (params.get('ttclid')) return 'tt';
      return '';
    } catch (e) { return ''; }
  }

  function readStored() {
    try {
      var raw = localStorage.getItem(ATTR_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.acquisition_source || !parsed.ts) return null;
      if (Date.now() - parsed.ts > ATTR_TTL_MS) return null;
      return parsed;
    } catch (e) { return null; }
  }
  function recordChannel(channel) {
    var v = sanitize(channel);
    if (!v) return;
    try {
      localStorage.setItem(ATTR_KEY, JSON.stringify({ acquisition_source: v, ts: Date.now() }));
    } catch (e) {}
  }
  function acquisitionSource() {
    var stored = readStored();
    return stored ? stored.acquisition_source : undefined;
  }

  // Run the recorder for this load.
  var urlChannel = channelFromUrl();
  if (urlChannel) recordChannel(urlChannel);
  var current = acquisitionSource();
  if (current) {
    try {
      if (window.posthog && typeof window.posthog.register === 'function') {
        window.posthog.register({ acquisition_source: current });
      }
    } catch (e) {}
  }

  return {
    ready: ready,
    capture: capture,
    distinctId: distinctId,
    sessionId: sessionId,
    acquisitionSource: acquisitionSource,
    recordChannel: recordChannel,
    channelFromUrl: channelFromUrl
  };
})();

// Keep the visitor's PostHog distinct_id on the Shopify cart as the ph_distinct_id attribute.
// Shopify copies cart attributes onto the order, and the PostHog function
// "Shopify orders → checkout_completed" (fed by Shopify's Order creation webhook) reads it to
// alias this visitor to the Shopify customer, so the order lands on the same PostHog person as
// product_viewed, add_to_cart and checkout_started. It re-stamps whenever the visitor ID or the
// cart changes (Shopify starts a new cart after every order). Every method is fail-safe: never throws.
window.tvPhCart = (function () {
  var KEY = 'tv_ph_cart_stamp';
  function root() {
    try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch (e) { return '/'; }
  }
  function cartToken() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
      return m ? decodeURIComponent(m[1]).split('?')[0] : '';
    } catch (e) { return ''; }
  }
  // Resolves true once the real PostHog library has loaded, false after `ms` (e.g. ad blocker).
  function whenReady(ms) {
    return new Promise(function (resolve) {
      var waited = 0;
      (function check() {
        if (window.hpPh && window.hpPh.ready()) return resolve(true);
        if (waited >= ms) return resolve(false);
        waited += 100;
        setTimeout(check, 100);
      })();
    });
  }
  // Writes ph_distinct_id to the cart. force=true skips the "already stamped" check.
  function stamp(force) {
    try {
      var id = window.hpPh && window.hpPh.distinctId();
      if (!id) return Promise.resolve(false);
      var key = id + '|' + cartToken();
      try { if (!force && sessionStorage.getItem(KEY) === key) return Promise.resolve(true); } catch (e) {}
      return fetch(root() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { ph_distinct_id: id } })
      }).then(function (r) {
        if (!r.ok) return false;
        try { sessionStorage.setItem(KEY, id + '|' + cartToken()); } catch (e) {}
        // The response is the whole cart: keep it for checkout_started.
        return r.json().then(function (c) {
          try { if (window.tvPhCheckout) window.tvPhCheckout.setCart(c); } catch (e) {}
          return true;
        }, function () { return true; });
      }).catch(function () { return false; });
    } catch (e) { return Promise.resolve(false); }
  }
  whenReady(15000).then(function (ok) { if (ok) stamp(false); });
  // Identified customer arriving from a veterinarians.org advertorial (see tvPhCross): link the
  // advertorial's anonymous id to this customer so lp_view / lp_cta_click join their journey.
  whenReady(15000).then(function (ok) {
    try {
      var alias = ok && window.tvPhCross && window.tvPhCross.aliasTo;
      if (alias && typeof window.posthog.alias === 'function') window.posthog.alias(alias);
    } catch (e) {}
  });
  return { stamp: stamp, whenReady: whenReady, root: root };
})();

// checkout_started: captured when the shopper leaves the theme for checkout. Covers the cart page
// and cart drawer "Check out" buttons and the accelerated checkout buttons (Shop Pay, Apple Pay,
// Google Pay); the PDP Buy Now button calls started('buy_now') from assets/tv-pdp.js.
// It's captured here rather than in a Customer Events pixel because Shopify runs no pixels on
// the Shop Pay checkout at shop.app, so a pixel misses every shopper Shop Pay recognizes.
// Properties come from the cart: the page renders it (snippets/tv-ph-cart.liquid) and this
// re-reads /cart.js after every cart:update. Every method is fail-safe: never throws.
window.tvPhCheckout = (function () {
  var cart = null;
  var lastSent = 0;
  var refreshTimer = null;

  function setCart(c) {
    if (c && c.items) cart = c;
  }
  function current() {
    if (!cart) {
      try {
        var el = document.getElementById('tv-ph-cart');
        if (el) setCart(JSON.parse(el.textContent));
      } catch (e) {}
    }
    return cart;
  }
  function refresh() {
    try {
      return fetch(window.tvPhCart.root() + 'cart.js', {
        credentials: 'same-origin', headers: { Accept: 'application/json' }
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { setCart(c); return cart; })
        .catch(function () { return cart; });
    } catch (e) { return Promise.resolve(cart); }
  }
  function props(source) {
    var p = { checkout_source: source };
    var c = current();
    if (!c) return p;
    p.value = Number(c.total_price) / 100;
    p.subtotal = Number(c.items_subtotal_price) / 100;
    p.currency = c.currency || undefined;
    p.item_count = c.item_count;
    p.cart_token = c.token ? String(c.token).split('?')[0] : undefined;
    p.items = (c.items || []).map(function (i) {
      return {
        product_id: i.product_id,
        product_title: i.product_title,
        variant_id: i.variant_id,
        variant_title: i.variant_title || undefined,
        sku: i.sku || undefined,
        price: Number(i.final_price) / 100,
        quantity: i.quantity
      };
    });
    return p;
  }
  // source: buy_now | cart_page | cart_drawer | accelerated_cart | accelerated_product
  function started(source) {
    try {
      var now = Date.now();
      if (now - lastSent < 2000) return; // double clicks, or Buy Now plus the button's own click
      lastSent = now;
      if (!window.posthog || typeof window.posthog.capture !== 'function') return;
      // sendBeacon so leaving the page for checkout can't cancel the request.
      window.posthog.capture('checkout_started', props(source), { transport: 'sendBeacon', send_instantly: true });
      // Make sure ph_distinct_id is on the cart (normally already done on page load).
      if (window.tvPhCart) window.tvPhCart.stamp(false);
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    try {
      var t = event.target;
      if (!t || !t.closest) return;
      var btn = t.closest('button[name="checkout"], input[name="checkout"]');
      if (btn) {
        if (btn.disabled) return;
        started(btn.closest('cart-drawer-component, .cart-drawer') ? 'cart_drawer' : 'cart_page');
        return;
      }
      var acc = t.closest('shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .additional-checkout-buttons, .shopify-payment-button');
      if (acc) {
        started(acc.closest('shopify-accelerated-checkout-cart, .additional-checkout-buttons') ? 'accelerated_cart' : 'accelerated_product');
      }
    } catch (e) {}
  }, true);

  // Keep the cart current after drawer/cart page changes (debounced).
  document.addEventListener('cart:update', function () {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 300);
  });
  // Back/forward cache restores an old page (e.g. returning from checkout): re-read the cart.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  return { started: started, setCart: setCart, refresh: refresh };
})();

// add_to_cart for Horizon product forms (cart drawer and quick add). The TotalVet PDP's
// Buy Now button skips this path and captures add_to_cart itself in assets/tv-pdp.js.
document.addEventListener('cart:update', function (event) {
  try {
    var detail = event.detail || {};
    var data = detail.data || {};
    if (data.source !== 'product-form-component' || data.didError) return;
    var items = (detail.resource && detail.resource.items) || [];
    var line = null;
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(detail.sourceId)) { line = items[i]; break; }
    }
    if (!line) {
      for (var j = 0; j < items.length; j++) {
        if (String(items[j].product_id) === String(data.productId)) { line = items[j]; break; }
      }
    }
    var qty = Number(data.itemCount) || 1;
    var price = line ? Number(line.price) / 100 : undefined;
    window.hpPh.capture('add_to_cart', {
      product_id: line ? line.product_id : Number(data.productId) || undefined,
      product_title: line ? line.product_title : undefined,
      variant_id: line ? line.variant_id : undefined,
      variant_title: line ? line.variant_title : undefined,
      sku: line && line.sku ? line.sku : undefined,
      price: price,
      quantity: qty,
      value: price != null ? Math.round(price * qty * 100) / 100 : undefined,
      currency: detail.resource && detail.resource.currency ? detail.resource.currency : undefined,
      add_source: 'product_form'
    });
    window.tvPhCart.stamp(false);
  } catch (e) {}
});

// Identify by email at every capture point (VETS-13249). The PostHog distinct_id for a known
// person is their email, lowercased: the same key layout/theme.liquid uses for logged-in
// customers, the order webhook uses for buyers, and app.total.vet uses after login, so one
// human is one PostHog person across all of them. Submit-only: nothing is read while typing.
// Covers every form on the page with an email field (home signup, newsletter block, contact
// form, blog comments, gift cards) and Klaviyo's own popup/embed forms. Every method is
// fail-safe: never throws.
window.tvPhEmail = (function () {
  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var lastCaptured = '';

  function normalize(value) {
    try { return String(value || '').trim().toLowerCase(); } catch (e) { return ''; }
  }
  // identify(email, source[, extra]) -> true when PostHog accepted a valid email.
  function identify(email, source, extra) {
    try {
      var e = normalize(email);
      if (!RE.test(e)) return false;
      if (!window.posthog || typeof window.posthog.identify !== 'function') return false;
      var current = window.hpPh && window.hpPh.distinctId();
      if (current !== e) window.posthog.identify(e, { email: e });
      if (e !== lastCaptured) {
        lastCaptured = e;
        var props = { email_source: source || 'unknown' };
        if (extra) { for (var k in extra) { if (extra[k] != null) props[k] = extra[k]; } }
        // sendBeacon: most of these forms reload the page right after submit.
        window.posthog.capture('email_captured', props, { transport: 'sendBeacon', send_instantly: true });
      }
      // The cart attribute should carry the new distinct_id for the order webhook.
      if (window.tvPhCart) window.tvPhCart.stamp(true);
      return true;
    } catch (err) { return false; }
  }
  function formSource(form) {
    try {
      if (form.closest('tv-home-signup-form')) return 'home_signup';
      if (form.classList.contains('email-signup__form')) return 'newsletter_block';
      if (form.classList.contains('contact-form__form')) return 'contact_form';
      if (form.querySelector('input[name="comment[email]"]')) return 'blog_comment';
      if (form.querySelector('input[name="properties[Recipient email]"]')) return 'gift_card';
      var action = String(form.getAttribute('action') || '');
      if (action.indexOf('/account') > -1) return 'account_form';
      return 'form:' + (form.id || action || 'unknown');
    } catch (e) { return 'unknown'; }
  }
  // Capture phase: runs before the form's own handler, whether it posts, fetches or preventDefaults.
  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var input = form.querySelector('input[type="email"], input[name="contact[email]"], input[name="customer[email]"]');
      if (!input || !input.value) return;
      identify(input.value, formSource(form));
    } catch (e) {}
  }, true);
  // Klaviyo onsite forms (popups, flyouts, embeds) announce submits on window.
  window.addEventListener('klaviyoForms', function (event) {
    try {
      var d = event.detail || {};
      if (d.type !== 'submit') return;
      var md = d.metaData || {};
      identify(md.$email || md.email, 'klaviyo_form', { klaviyo_form_id: d.formId });
    } catch (e) {}
  });
  // Logout happens on Shopify's hosted account pages, not in the theme: when a page loads with
  // no customer but this browser was identified as one, reset so the next visitor on a shared
  // device doesn't inherit the previous customer's identity.
  try {
    if (window.tvPhCustomer === false && localStorage.getItem('tv_ph_customer')) {
      localStorage.removeItem('tv_ph_customer');
      if (window.posthog && typeof window.posthog.reset === 'function') window.posthog.reset();
    }
  } catch (e) {}

  return { identify: identify, normalize: normalize };
})();
